import { useQuery } from '@tanstack/react-query';
import { PaginatedAuditLogDto } from '@aphp-ema/common/audit';
import { getAuditLogs } from './auditLogs.api';
import { auditLogsQueryKeys } from './queryKeys';

export const useGetAuditLogs = (page = 1, limit = 100) => {
  return useQuery<PaginatedAuditLogDto, Error>({
    queryKey: auditLogsQueryKeys.list(),
    queryFn: () => getAuditLogs(page, limit),
    staleTime: 15 * 1000, //  15 seconds
  });
};
